import { RemoteVideoTrack, VideoPlayer } from '..';
import RtcError from '../common/rtc-error';
import { ConnectionState, ILocalTrack, IRemoteTrack, IRoom, ITrack, MULTI_VIDEO_DATA_TYPE, PublishedUser, RemoteStreamType, VideoCodec } from '../enums';
import { AudioSource } from '../manager/audio-mixer';
import { ILog } from '../utils/log/logger-manager';
import { NALU } from '../utils/nalu';
import { INNER_EVENT } from './inner-type';
export interface InnerEventTypes {
  // Room 相关
  [INNER_EVENT.ROOM_DESTROY]: [{ room: IRoom; }];

  // 进房相关
  [INNER_EVENT.JOIN_START]: [{ room: IRoom, roomId: number | string, params: any; }];
  [INNER_EVENT.JOIN_SCHEDULE_SUCCESS]: [{ room: IRoom, schedule: ScheduleResult, detailCost?: ScheduleDetailCost }];
  [INNER_EVENT.JOIN_SIGNAL_CONNECTION_START]: [{ room: IRoom }];
  [INNER_EVENT.JOIN_SIGNAL_CONNECTION_END]: [{ room: IRoom, error?: any }];
  [INNER_EVENT.JOIN_SEND_CMD]: [{ room: IRoom }];
  [INNER_EVENT.JOIN_RECEIVED_CMD_RES]: [{ room: IRoom, code: number }];
  [INNER_EVENT.JOIN_SUCCESS]: [{ room: IRoom }];
  [INNER_EVENT.JOIN_FAILED]: [{ room: IRoom, error: any }];
  [INNER_EVENT.WHIP_REQUEST_COST]: [{ room: IRoom, cost: number }];
  [INNER_EVENT.WHIP_PULL_RESULT]: [{ room: IRoom, code: number }];

  // 退房相关
  [INNER_EVENT.LEAVE_START]: [{ room: IRoom; roomId: string }];
  [INNER_EVENT.LEAVE_SEND_CMD]: [{ room: IRoom; }];
  [INNER_EVENT.LEAVE_SUCCESS]: [{ room: IRoom, roomId: string; }];

  // Track 相关
  [INNER_EVENT.TRACK_MUTED]: [{ track: ITrack; }];
  [INNER_EVENT.TRACK_UNMUTED]: [{ track: ITrack; }];
  [INNER_EVENT.LOCAL_TRACK_CAPTURE_START]: [{ track: ILocalTrack; }];
  [INNER_EVENT.LOCAL_TRACK_CAPTURE_SUCCESS]: [{ track: ILocalTrack; cost?: number; profile?: VideoProfile | AudioProfile; room?: IRoom }];
  [INNER_EVENT.LOCAL_TRACK_CAPTURE_FAILED]: [{ track: ILocalTrack, error: any; }];
  [INNER_EVENT.LOCAL_TRACK_PUBLISHED]: [{ track: ILocalTrack, room: IRoom; }];
  [INNER_EVENT.LOCAL_TRACK_UNPUBLISHED]: [{ track: ILocalTrack; }];
  [INNER_EVENT.LOCAL_TRACK_REPLACED]: [{ track: ILocalTrack; }];
  [INNER_EVENT.SWITCH_DEVICE_SUCCESS]: [{ track: ILocalTrack; }];
  [INNER_EVENT.REMOTE_TRACK_SUBSCRIBED]: [{ track: IRemoteTrack; }];
  [INNER_EVENT.REMOTE_TRACK_UNSUBSCRIBED]: [{ track: IRemoteTrack; }];
  [INNER_EVENT.LOCAL_TRACK_RECAPTURE]: [{ track: ILocalTrack; error?: RtcError | Error }];
  [INNER_EVENT.LOCAL_AUDIO_STARTED]: [{ userId: string; room: IRoom }];
  [INNER_EVENT.LOCAL_AUDIO_STOPPED]: [{ userId: string; room: IRoom }];
  [INNER_EVENT.REMOTE_AUDIO_STARTED]: [{ userId: string; room: IRoom }];
  [INNER_EVENT.REMOTE_AUDIO_STOPPED]: [{ userId: string; room: IRoom }];
  [INNER_EVENT.LOCAL_TRACK_STOPPED]: [{ track: ILocalTrack }];
  [INNER_EVENT.LOCAL_VIDEO_TRACK_PREPROCESSED]: [{ mediaTrack: MediaStreamTrack; profile?: VideoProfile; room?: IRoom;}];
  // 推流相关
  [INNER_EVENT.PUBLISH_START]: [{ room: IRoom; }];
  [INNER_EVENT.SEND_FIRST_VIDEO_FRAME]: [{ room: IRoom; }];
  [INNER_EVENT.PUBLISH_FAILED]: [{ room: IRoom; }];

  // 订阅相关
  [INNER_EVENT.SUBSCRIBE_START]: [{ room: IRoom, streamType: RemoteStreamType, remotePublishedUser: PublishedUser, subscribeState: SubscribeState; }];
  [INNER_EVENT.SUBSCRIBE_SUCCESS]: [{
    room: IRoom,
    streamType: RemoteStreamType,
    remotePublishedUser: PublishedUser,
  }];
  [INNER_EVENT.UNSUBSCRIBE_SUCCESS]: [{
    room: IRoom,
    streamType: RemoteStreamType,
    remotePublishedUser: PublishedUser,
  }];
  [INNER_EVENT.SUBSCRIBE_FAILED]: [{ room: IRoom, remoteTracks: IRemoteTrack[] }];


  // 远端用户推流状态相关
  [INNER_EVENT.RECEIVED_PUBLISHED_USER_LIST]: [{ room: IRoom, publishedUserList: BasePublishedUserInfo[]; isWhipPreFill?: boolean; }];
  [INNER_EVENT.REMOTE_PUBLISH_STATE_CHANGED]: [{ room: IRoom, prevMuteState: MuteState, muteState: MuteState; }];

  // 播放相关
  [INNER_EVENT.REMOTE_VIDEO_PLAY_START]: [{ player: VideoPlayer, track: RemoteVideoTrack }];
  [INNER_EVENT.REMOTE_VIDEO_PLAY_FINISH]: [{ player: VideoPlayer, track: RemoteVideoTrack }];
  [INNER_EVENT.PLAY_TRACK_START]: [{ track: ITrack; }];
  [INNER_EVENT.PLAYER_STATE_CHANGED]: [{ track: ITrack, type: AudioOrVideo, state: string, reason: string; }];
  [INNER_EVENT.VIDEO_LOADED_DATA]: [{ track: ITrack; }];
  [INNER_EVENT.AUDIO_CONTEXT_LONG_SUSPENDED]: [{ isSuspended: boolean; }];

  // 连接相关
  [INNER_EVENT.SIGNAL_CONNECTION_STATE_CHANGED]: [{ room: IRoom, prevState: ConnectionState, state: ConnectionState; }];
  [INNER_EVENT.SINGLE_CONNECTION_STAT]: [{ room: IRoom, stat: { ice: number; dtls: number; peerConnection: number }; }];
  [INNER_EVENT.PEER_CONNECTION_STATE_CHANGED]: [{ room: IRoom, prevState: ConnectionState, state: ConnectionState, remoteUserId?: string; }];
  [INNER_EVENT.SPC_RECONNECTED]: [{ room: IRoom }];

  // 切换房间
  [INNER_EVENT.SWITCH_ROOM_START]: [{ room: IRoom }];
  [INNER_EVENT.SWITCH_ROOM_SUCCESS]: [{ room: IRoom, currentRoomId: number | string, targetRoomId: number | string; }];
  [INNER_EVENT.SWITCH_ROOM_FAILED]: [{ room: IRoom, error: any; }];

  // 其他
  [INNER_EVENT.HEARTBEAT_REPORT]: [{ room: IRoom, report: HearBeatReport; }];
  [INNER_EVENT.AUDIO_LEVEL_INTERVAL]: [{ interval: number; }];
  [INNER_EVENT.NETWORK_QUALITY]: [{ room: IRoom, uplink: { rtt: number; loss: number; }, downlinks: { userId: string; rtt: number; loss: number; audioDelay?: number; videoDelay?: number; }[]; }];
  [INNER_EVENT.AUTOPLAY_DIALOG_CLICK_CONFIRM]: [];
  [INNER_EVENT.VIDEO_CODEC_IMPLEMENTATION_CHANGED]: [{ userId: string, remoteUserId?: string; streamType?: MULTI_VIDEO_DATA_TYPE, implementation: string; prevImplementation: string; codec: VideoCodec; isHWCodec: boolean; }];
  [INNER_EVENT.QUALITY_LIMITATION_CHANGED]: [{ userId: string, streamType: MULTI_VIDEO_DATA_TYPE, reason: string; prevReason: string, isQosClearFirst?: boolean; }];
  [INNER_EVENT.LOG]: [{ log: ILog;}];
  [INNER_EVENT.AUDIO_PROCESSOR_DEBUG]: [{ room: IRoom, data: { timestamp: number, currentFrame: number, message: string }, type: string ;}]
  [INNER_EVENT.SSO_SWITCH]: [{ enable: boolean ;}]
  [INNER_EVENT.SEI_MESSAGE]: [{ room: IRoom, nalu: NALU }]
  [INNER_EVENT.USER_PAUSE_IN_PIP]: [{ room: IRoom, track: IRemoteTrack }],
  [INNER_EVENT.USER_RESUME_IN_PIP]: [{ room: IRoom, track: IRemoteTrack }],
  [INNER_EVENT.ENTER_PICTURE_IN_PICTURE]: [{ room: IRoom, track: IRemoteTrack }],
  [INNER_EVENT.LEAVE_PICTURE_IN_PICTURE]: [{ room: IRoom, track: IRemoteTrack }],
}

export default INNER_EVENT;
